import { ReactNode } from 'react'
import { useDndContext, useDroppable } from '@dnd-kit/core'
import { cn } from '@/lib/utils'
import Card from 'app/frontend/base/components/Card'
import {
  parseAssignmentDropLocation,
  parseGroupDroppableId,
} from './assignmentDnd'

type Props = {
  id: string
  className?: string
  onClick?: () => void
  children: ReactNode
}

const AssignmentGroupDropTarget = ({
  id,
  className,
  onClick,
  children,
}: Props) => {
  const { over } = useDndContext()
  const { setNodeRef } = useDroppable({ id })
  const groupLocation = parseGroupDroppableId(id)
  const overLocation = over
    ? parseAssignmentDropLocation(String(over.id))
    : null
  const isOver =
    Boolean(groupLocation) &&
    Boolean(overLocation) &&
    groupLocation?.abilityKey === overLocation?.abilityKey &&
    groupLocation?.scopeId === overLocation?.scopeId &&
    groupLocation?.groupIndex === overLocation?.groupIndex
  return (
    <Card
      ref={setNodeRef}
      className={cn(
        className,
        isOver && 'ring-1 ring-primary ring-offset-3 ring-offset-card',
      )}
      onClick={onClick}
    >
      {children}
    </Card>
  )
}

export default AssignmentGroupDropTarget
